var colours = {
  blue: '#3a86ff',
  backgroundGrey: '#eff0f1'
}

export default colours;


// WEBPACK FOOTER //
// ./src/shared/colours.js